import { useState } from "react";
import api, { formatApiErrorDetail } from "../../lib/api";
import { toast } from "sonner";

const currentStatus = (inv) => {
  if (inv.status !== "paid") return "pending";
  return inv.payment_method === "razorpay" ? "paid_razorpay" : "paid_manual";
};

export function StatusEditor({ inv, onSaved }) {
  const current = currentStatus(inv);
  const [val, setVal] = useState(current);
  const [saving, setSaving] = useState(false);
  const save = async () => {
    setSaving(true);
    try {
      await api.patch(`/rent-invoices/${inv.id}/status`, { status: val });
      toast.success(val === "paid_manual" ? "Marked paid (manual)" : "Moved back to pending");
      onSaved();
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setSaving(false); }
  };
  return (
    <span className="inline-flex items-center gap-1.5">
      <select value={val} onChange={(e) => setVal(e.target.value)}
              data-testid={`status-select-${inv.id}`}
              className="border border-slate-300 px-2 py-1.5 text-xs bg-white">
        <option value="pending">Pending</option>
        <option value="paid_manual">Paid (Manual)</option>
        {current === "paid_razorpay" && <option value="paid_razorpay" disabled>Paid (Razorpay)</option>}
      </select>
      <button onClick={save} disabled={val === current || saving}
              data-testid={`status-save-${inv.id}`}
              className="bg-slate-900 text-white px-3 py-1.5 text-xs disabled:opacity-40 hover:bg-slate-800">
        {saving ? "…" : "Save"}
      </button>
    </span>
  );
}
